import React from "react";
import {
  Grid,
  Segment,
  Header,
  Icon,
  Table,
  Progress,
  Label,
  Message,
  Loader,
  Tab,
} from "semantic-ui-react";
import { StatCard } from "../../StatCard";
import "./OperationsTab.scss";

export function OperationsTab(props) {
  const { operationalData, teachingData } = props;

  if (!operationalData) {
    return <Loader active>Cargando métricas operacionales...</Loader>;
  }

  const docCompliance = operationalData.documentCompliance || {};
  const forumActivity = operationalData.forumActivity || {};

  return (
    <Tab.Pane>
      <Grid stackable>
        {/* Document Compliance Section */}
        {docCompliance && (
          <Grid.Row>
            <Grid.Column>
              <Segment color="blue">
                <Header as="h3">
                  <Icon name="file alternate outline" />
                  <Header.Content>
                    Cumplimiento de Documentos
                    <Header.Subheader>
                      Control de entregas documentales de estudiantes
                    </Header.Subheader>
                  </Header.Content>
                </Header>

                <Grid stackable>
                  <Grid.Row columns={4}>
                    <Grid.Column>
                      <StatCard
                        title="Documentos Requeridos"
                        value={docCompliance.totalDocuments || 0}
                        icon="folder open"
                        color="#2185d0"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <StatCard
                        title="Total Estudiantes"
                        value={docCompliance.totalStudents || 0}
                        icon="users"
                        color="#00b5ad"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <StatCard
                        title="Entregas Esperadas"
                        value={docCompliance.expectedSubmissions || 0}
                        icon="clipboard list"
                        color="#a333c8"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <StatCard
                        title="Entregas Realizadas"
                        value={docCompliance.actualSubmissions || 0}
                        icon="check circle"
                        color={
                          docCompliance.actualSubmissions > 0
                            ? "#21ba45"
                            : "#db2828"
                        }
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row>
                    <Grid.Column width={16}>
                      <Header as="h4">Tasa de Cumplimiento</Header>
                      <Progress
                        percent={parseFloat(docCompliance.complianceRate || 0)}
                        color={
                          docCompliance.complianceRate >= 80
                            ? "green"
                            : docCompliance.complianceRate >= 50
                            ? "yellow"
                            : "red"
                        }
                        size="large"
                      >
                        {parseFloat(docCompliance.complianceRate || 0).toFixed(
                          2
                        )}
                        % de documentos entregados
                      </Progress>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        )}

        {/* Forum Activity Section */}
        {forumActivity && (
          <Grid.Row>
            <Grid.Column>
              <Segment color="teal">
                <Header as="h3">
                  <Icon name="comments" />
                  <Header.Content>
                    Actividad del Foro
                    <Header.Subheader>
                      Estadísticas de participación en foros académicos
                    </Header.Subheader>
                  </Header.Content>
                </Header>

                <Grid stackable>
                  <Grid.Row columns={3}>
                    <Grid.Column>
                      <StatCard
                        title="Total de Publicaciones"
                        value={forumActivity.totalPosts || 0}
                        icon="comment alternate"
                        color="#00b5ad"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <StatCard
                        title="Publicaciones Resueltas"
                        value={forumActivity.solvedPosts || 0}
                        icon="check circle"
                        color="#21ba45"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <StatCard
                        title="Publicaciones Sin Resolver"
                        value={forumActivity.unsolvedPosts || 0}
                        icon="question circle"
                        color="#f2711c"
                      />
                    </Grid.Column>
                  </Grid.Row>

                  <Grid.Row columns={3}>
                    <Grid.Column>
                      <Segment textAlign="center" color="teal">
                        <Header as="h4" color="teal">
                          <Icon name="percent" />
                          Tasa de Resolución
                        </Header>
                        <Header as="h2" color="teal">
                          {parseFloat(
                            forumActivity.resolutionRate || 0
                          ).toFixed(2)}
                          %
                        </Header>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment textAlign="center" color="blue">
                        <Header as="h4" color="blue">
                          <Icon name="reply" />
                          Total de Respuestas
                        </Header>
                        <Header as="h2" color="blue">
                          {forumActivity.totalAnswers || 0}
                        </Header>
                      </Segment>
                    </Grid.Column>
                    <Grid.Column>
                      <Segment textAlign="center" color="violet">
                        <Header as="h4" color="violet">
                          <Icon name="chart line" />
                          Promedio Respuestas/Post
                        </Header>
                        <Header as="h2" color="violet">
                          {parseFloat(
                            forumActivity.averageAnswersPerPost || 0
                          ).toFixed(2)}
                        </Header>
                      </Segment>
                    </Grid.Column>
                  </Grid.Row>

                  {forumActivity.totalPosts === 0 && (
                    <Grid.Row>
                      <Grid.Column>
                        <Message info icon>
                          <Icon name="info circle" />
                          <Message.Content>
                            <Message.Header>
                              No hay actividad en los foros
                            </Message.Header>
                            <p>
                              Aún no se han creado publicaciones en los foros
                              del ciclo académico seleccionado.
                            </p>
                          </Message.Content>
                        </Message>
                      </Grid.Column>
                    </Grid.Row>
                  )}

                  {forumActivity.totalPosts > 0 &&
                    forumActivity.unsolvedPosts > 0 && (
                      <Grid.Row>
                        <Grid.Column>
                          <Message warning icon>
                            <Icon name="exclamation triangle" />
                            <Message.Content>
                              <Message.Header>
                                Atención requerida
                              </Message.Header>
                              <p>
                                Hay{" "}
                                <strong>{forumActivity.unsolvedPosts}</strong>{" "}
                                publicaciones sin resolver que requieren
                                atención.
                              </p>
                            </Message.Content>
                          </Message>
                        </Grid.Column>
                      </Grid.Row>
                    )}
                </Grid>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        )}

        {/* Teaching Data Section */}
        {teachingData?.teacherWorkload?.length > 0 && (
          <Grid.Row>
            <Grid.Column>
              <Segment color="orange">
                <Header as="h3">
                  <Icon name="user tie" />
                  <Header.Content>
                    Carga Docente
                    <Header.Subheader>
                      Distribución de cursos y estudiantes por docente
                    </Header.Subheader>
                  </Header.Content>
                </Header>

                {teachingData.summary && (
                  <Grid stackable style={{ marginBottom: "1rem" }}>
                    <Grid.Row columns={2}>
                      <Grid.Column>
                        <StatCard
                          title="Total Docentes"
                          value={teachingData.summary.totalTeachers || 0}
                          icon="users"
                          color="#f2711c"
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <StatCard
                          title="Promedio Cursos/Docente"
                          value={
                            teachingData.summary.averageCoursesPerTeacher || 0
                          }
                          icon="book"
                          color="#00b5ad"
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                )}

                <Table celled striped>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Docente</Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Cursos Asignados
                      </Table.HeaderCell>
                      <Table.HeaderCell textAlign="center">
                        Carga
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {teachingData.teacherWorkload
                      .slice(0, 10)
                      .map((teacher, index) => {
                        const workloadLevel =
                          teacher.courseCount >= 6
                            ? "high"
                            : teacher.courseCount >= 4
                            ? "medium"
                            : "low";
                        return (
                          <Table.Row key={index}>
                            <Table.Cell>
                              <Icon name="user" />
                              {teacher.teacherName}
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              <Label color="blue" size="large">
                                {teacher.courseCount}
                              </Label>
                            </Table.Cell>
                            <Table.Cell textAlign="center">
                              <Label
                                color={
                                  workloadLevel === "high"
                                    ? "red"
                                    : workloadLevel === "medium"
                                    ? "yellow"
                                    : "green"
                                }
                              >
                                {workloadLevel === "high"
                                  ? "Alta"
                                  : workloadLevel === "medium"
                                  ? "Media"
                                  : "Baja"}
                              </Label>
                            </Table.Cell>
                          </Table.Row>
                        );
                      })}
                  </Table.Body>
                </Table>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        )}
      </Grid>
    </Tab.Pane>
  );
}
